(function () {
  "use strict";

  class GbCarousel extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;

      this._viewport = document.createElement("div");
      this._viewport.className = "gbvc-viewport";

      this._track = document.createElement("div");
      this._track.className = "gbvc-track";

      this._prev = document.createElement("button");
      this._prev.type = "button";
      this._prev.className = "gbvc-nav gbvc-prev";
      this._prev.setAttribute("aria-label", "Previous");
      this._prev.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 185.343 185.343\"><path d=\"M51.707 185.343a10.692 10.692 0 0 1-7.593-3.149 10.724 10.724 0 0 1 0-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 0 1-7.587 3.15z\"/></svg>";

      this._next = document.createElement("button");
      this._next.type = "button";
      this._next.className = "gbvc-nav gbvc-next";
      this._next.setAttribute("aria-label", "Next");
      this._next.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 185.343 185.343\"><path d=\"M51.707 185.343a10.692 10.692 0 0 1-7.593-3.149 10.724 10.724 0 0 1 0-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 0 1-7.587 3.15z\"/></svg>";

      var items = Array.prototype.slice.call(this.querySelectorAll('[slot="item"]'));
      var fallbackItems = items.length ? items : Array.prototype.slice.call(this.children);

      var self = this;

      this._slides = fallbackItems.map(function (node) {
        var slide = document.createElement("div");
        slide.className = "gbvc-slide";

        if (node.getAttribute && node.getAttribute("slot")) {
          node.removeAttribute("slot");
        }

        slide.appendChild(node);
        self._track.appendChild(slide);
        return slide;
      });

      this._viewport.appendChild(this._track);

      this.textContent = "";
      this.appendChild(this._prev);
      this.appendChild(this._viewport);
      this.appendChild(this._next);

      this._onPrev = function () { self.scrollBySlides(-1); };
      this._onNext = function () { self.scrollBySlides(1); };

      this._prev.addEventListener("click", this._onPrev);
      this._next.addEventListener("click", this._onNext);

      this._onScroll = function () { self.updateNav(); };
      this._viewport.addEventListener("scroll", this._onScroll, { passive: true });

      this._io = new IntersectionObserver(function (entries) {
        var best = null;

        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!best || e.intersectionRatio > best.intersectionRatio) {
            best = e;
          }
        }

        if (best && best.isIntersecting) {
          self._activeIndex = self._slides.indexOf(best.target);
          self.pauseNonActiveVideos(self._activeIndex);
          self.updateNav();
        }
      }, { root: this._viewport, threshold: [0.6] });

      for (var i = 0; i < this._slides.length; i++) {
        this._io.observe(this._slides[i]);
      }

      this._activeIndex = 0;
      this.updateNav();
      this.pauseNonActiveVideos(0);
    }

    disconnectedCallback() {
      if (!this._mounted) return;
      this._mounted = false;

      if (this._prev && this._onPrev) this._prev.removeEventListener("click", this._onPrev);
      if (this._next && this._onNext) this._next.removeEventListener("click", this._onNext);
      if (this._viewport && this._onScroll) this._viewport.removeEventListener("scroll", this._onScroll);

      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
    }

    scrollBySlides(dir) {
      var next = clamp(this._activeIndex + dir, 0, this._slides.length - 1);
      this.scrollToIndex(next);
    }

    scrollToIndex(i) {
      if (!this._slides.length) return;
      var slide = this._slides[i];
      if (!slide) return;

      var left = slide.offsetLeft;
      this._viewport.scrollTo({ left: left, behavior: "smooth" });
      this._activeIndex = i;

      this.pauseNonActiveVideos(i);
      this.updateNav();
    }

    updateNav() {
      var n = this._slides.length;
      var i = this.getActiveIndexFromScroll();
      this._activeIndex = i;

      this._prev.disabled = i <= 0;
      this._next.disabled = i >= n - 1;
      this.toggleNavVisibility(n > 1);
    }

    toggleNavVisibility(show) {
      this._prev.style.display = show ? "" : "none";
      this._next.style.display = show ? "" : "none";
    }

    getActiveIndexFromScroll() {
      var x = this._viewport.scrollLeft;
      var bestIdx = 0;
      var bestDist = Infinity;

      for (var i = 0; i < this._slides.length; i++) {
        var d = Math.abs(this._slides[i].offsetLeft - x);
        if (d < bestDist) {
          bestDist = d;
          bestIdx = i;
        }
      }
      return bestIdx;
    }

    pauseNonActiveVideos(activeIndex) {
      for (var i = 0; i < this._slides.length; i++) {
        if (i === activeIndex) continue;

        var gbVideos = this._slides[i].querySelectorAll("gb-video");
        for (var j = 0; j < gbVideos.length; j++) {
          try { gbVideos[j].requestPauseVideo(); } catch (e) {}
        }
      }
    }
  }

  function clamp(v, a, b) {
    return Math.max(a, Math.min(b, v));
  }

  if (!customElements.get("gb-carousel")) {
    customElements.define("gb-carousel", GbCarousel);
  }

})();
